import { FormattedMessage } from "react-intl";
import { useAppSelector } from "../../app/hooks";
import { selectLanguage } from "../../services/localizationSlice";

const Footer = () => {
  const language = useAppSelector(selectLanguage);

  return (
    <div className="footer">
      <div className="footer-container">
        <div className="footer-copyright">&#169; IDEA StatiCa 2009-{new Date().getFullYear()}</div>
        <div className="footer-links-wrapper">
          <a
            href={`https://www.surveymonkey.com/r/connection-library${
              language.abbreviation === "CZ" ? "?lang=cs" : ""
            }`}
            className="footer-link"
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="GiveUsFeedback" defaultMessage="Give us feedback" />
          </a>
          <a
            href="https://www.ideastatica.com/contact"
            className="footer-link"
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="Help" defaultMessage="Help" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
